import React, {useEffect,useCallback} from 'react'
import {LANGS} from 'src/lib/translates/consts'
import {useAppDispatch, useAppSelector} from 'store'
import {refreshLetters} from 'store/letter/slice'
import {isStart} from 'store/secretword/selectors'
import {getTranslates, getLang} from 'store/translates/selectors'
import {setLanguage} from 'store/translates/slice'
import {clearShowCongratulateModal} from 'store/game/slice'
import {showModal} from 'store/modal/slice'
import {getRiddleDataThunk} from 'store/secretword/thunk'
import {getTranslatesThunk} from 'store/translates/thunk'
import {getLettersThunk} from 'store/letter/thunk'
import {initAnsweredIdsThunk} from 'store/game/thunk'
import type {LangType} from 'src/lib/translates/types'
import {setPageTitle} from 'src/lib/setPageTitle'
import {DesktopMenu} from './DesktopMenu'
import {MobileMenu} from './MobileMenu/MobileMenu'

export type LanguagesType = Array<{
  name: string
  value: LangType
}>

export type MenuProps = {
  messageStartGame: string
  currentLang: LangType
  languages: LanguagesType
  donateMessage?: string
  handleStartGame: () => void
  handleChangeLanguage: (value: LangType) => void
  handleDonate?: () => void
  handleOpenTop?: () => void
}

const Header = () => {
  const dispatch = useAppDispatch()
  const isStartPage = useAppSelector(isStart)
  const translates = useAppSelector(getTranslates)
  const currentLang = useAppSelector(getLang)

  useEffect(() => {
    if (translates?.TITLE) {
      setPageTitle(translates.TITLE)
    }
  }, [currentLang, translates])

  const handleStartGame = async () => {
    await dispatch(getRiddleDataThunk())
    dispatch(refreshLetters())
  }

  const handleChangeLanguage = useCallback(async (lang: LangType) => {
    dispatch(setLanguage(lang))
    dispatch(clearShowCongratulateModal())
    await dispatch(getTranslatesThunk())
    await dispatch(initAnsweredIdsThunk())
    if (!isStartPage) {
      await dispatch(getRiddleDataThunk())
      await dispatch(getLettersThunk())
      dispatch(refreshLetters())
    }
  }, [isStartPage])

  const handleOpenTop = useCallback(() => {
    dispatch(showModal({
      type: 'TopCup',
      props: {},
    }))
  }, [])

  const languages: LanguagesType = [
    {name: translates.RU, value: LANGS.RU},
    {name: translates.UK, value: LANGS.UK},
    {name: translates.EN, value: LANGS.EN},
    {name: translates.TR, value: LANGS.TR},
  ];

  const messageStartGame = isStartPage 
    ? translates.START_GAME
    : translates.NEW_GAME

  const props = {
    messageStartGame,
    currentLang,
    languages,
    handleStartGame,
    handleChangeLanguage,
    handleOpenTop: YSDK ? handleOpenTop : undefined,
  }

  return <>
    <DesktopMenu {...props} />
    <MobileMenu {...props} />
  </>;
}

export default Header
